import styled from "styled-components";

import headerFaixaJPG from "../../../assets/images/header_faixa.jpg";

export const Container = styled.div`
  display: flex;
  height: 160px;

  background-size: cover;
  background-position: center;
  background-image: url(${headerFaixaJPG});

  @media (max-width: 990px) {
    height: 228px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 70px;

  margin: 0 auto;
  max-width: 1200px;

  @media (max-width: 990px) {
    gap: 20px;
    flex-direction: column;
    justify-content:center;
    align-items: flex-start;
  }

  div {
    margin: 0;
    display: flex;
    flex-direction: column;
  }
`;

export const Title = styled.h2`
  font-size: 48px;
  font-weight: 600;
  color: #fff;
  font-family: 'Montserrat', sans-serif;
`;

export const Description = styled.p`
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
  text-transform: uppercase;
  color: #fff;
  font-family: 'Montserrat', sans-serif;

  padding-bottom: 14px;
`;

export const Separator = styled.div`
  width: 1px;
  height: 60px;
  background-color: rgba(255, 255, 255, .1);

  @media (max-width: 990px) {
    display: none !important;
  }
`;

export const Route = styled.p`
  display: flex;
  align-items: center;
  gap: 20px;

  font-size: 15px;
  font-weight: 500;
  color: #fff;
  font-family: 'Montserrat', sans-serif;

  span, a, p {
    cursor: pointer;
    color: #fff;
  }

  a:hover, p:hover {
    text-decoration: underline;
  }
`;
